import React, { useState, useEffect, useContext } from 'react'
import PracticeServiceTypeService from '../../../../../services/api/practice-service-type.service'
import PracticeServiceTypeForm from '../practice-service-type-form/PracticeServiceTypeForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import { store } from '../../../../../context/StateProvider'

const EditPracticeServiceType = (props) => {
    const { embed, id, exitEdit, inputChange, refresh } = props;
    const [formData, setFormData] = useState({})
    const [messages, setMessages] = useState({})
    const [isLoaded_form, setIsLoaded_form] = useState(false)
    const [apiResponse,setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const globalStateAndDispatch = useContext(store)
    const dispatch = globalStateAndDispatch.dispatch
    useEffect(() => {
        PracticeServiceTypeService.getPracticeServiceTypeById(props.id)
            .then(res => {
                setFormData(res.data)
                setIsLoaded_form(true)
            })
            .catch(err => { setIsLoaded_form(true) })
    }, [])

    const onSuccess = (message) => {
        dispatch({
            type: "setLocationServiceTypes",
            payload: null
        });
        dispatch({
            type: "setAllPracticeServiceTypes",
            payload:null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    
    const submitHandler = (data) => {
        setIsLoader(true)
        let reqObj = {...data}
        reqObj.unitPrice = data?.unitPrice?parseFloat(data.unitPrice):0
        reqObj.cost = data?.cost?parseFloat(data.cost):0
        reqObj.overhead = data?.overhead?parseFloat(data.overhead):0
        reqObj.defaultDuration = parseInt(reqObj.defaultDuration)
        if(!data.description){
            reqObj.description = ""
        }
        PracticeServiceTypeService.editPracticeServiceType(reqObj)
            .then(response => {
               setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            }).finally(() => {
                setIsLoader(false)
            });
    }

    return (
        <>
            {isLoader && <DimLoader />}
            {isLoaded_form && <PracticeServiceTypeForm submitHandler={submitHandler} initialData={formData} messages={messages} inputChange={inputChange} submitLabel="Update" exitHandler={()=>props.exitHandler() } onClose={props.onClose}/>}
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </>
    )
}

export default EditPracticeServiceType